import type { KeyboardEvent } from 'react';
import { Link } from 'react-router-dom';
import { cx } from '@platform/core/lib/cx';
import type { ISysTableProps } from './ISysTableProps';

/**
 * Таблиця системного модуля (прототип v4): картка радіус 12 з прокруткою вбік; рядок-заголовок на --surface2 (11px 600 великими літерами),
 * рядки — сітка з тим самим шаблоном колонок, відступ 9px 14px, лінія знизу; рядок-посилання підсвічується --surface2 при наведенні, рядок
 * з дією доступний з клавіатури (Tab, Enter).
 */
export function SysTable({ columns, minWidth, head, rows, empty, label }: ISysTableProps) {
  const grid = { gridTemplateColumns: columns, minWidth };
  return (
    <div className="sp-table" role="group" aria-label={label}>
      <div className="sp-row sp-row--head" style={grid}>
        {head.map((h, i) => <span key={i}>{h}</span>)}
      </div>
      {rows.map((r) => {
        const cells = r.cells.map((c, i) => <span key={i} className="sp-cell">{c}</span>);
        const className = cx('sp-row', (r.to || r.onClick) && 'is-link', r.current && 'is-current');
        if (r.to) return <Link key={r.key} className={className} style={grid} to={r.to}>{cells}</Link>;
        const keys = r.onClick ? { tabIndex: 0, role: 'link', onKeyDown: (e: KeyboardEvent<HTMLDivElement>) => { if (e.key === 'Enter') r.onClick?.(); } } : {};
        return <div key={r.key} className={className} style={grid} onClick={r.onClick} {...keys}>{cells}</div>;
      })}
      {!rows.length && empty && <div className="sp-empty">{empty}</div>}
    </div>
  );
}
